import { render } from "./TransitionView.vue?vue&type=template&id=54a3acfe&scoped=true"
import script from "./TransitionView.vue?vue&type=script&lang=js"
export * from "./TransitionView.vue?vue&type=script&lang=js"

import "./TransitionView.vue?vue&type=style&index=0&id=54a3acfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a3acfe"]])

export default __exports__